import React, { useState } from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const categories = [
    "All",
    "Lick Mats",
    "Slow Feeders",
    "Interactive Bowls",
    "Accessories",
    "Puzzles",
    "Toys",
  ];

  const filteredProducts =
    selectedCategory === "All"
      ? productData
      : productData.filter((product) => product.category === selectedCategory);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getCategoryIcon = (category) => {
    switch (category) {
      case "All":
        return "●";
      case "Lick Mats":
        return "◆";
      case "Slow Feeders":
        return "■";
      case "Interactive Bowls":
        return "▲";
      case "Accessories":
        return "★";
      default:
        return "•";
    }
  };

  return (
    <div className="shop main">
      <Header />

      <div className="shop-container">
        <div className="shop-hero">
          <div className="hero-content">
            <h1>Shop by Category</h1>
            <p>Designed for enrichment • Free delivery over $40</p>
          </div>
        </div>

        <div className="category-nav">
          {categories.map((category) => (
            <button
              key={category}
              className={`category-btn ${
                selectedCategory === category ? "active" : ""
              }`}
              onClick={() => setSelectedCategory(category)}
            >
              <span className="category-icon">{getCategoryIcon(category)}</span>
              {category}
            </button>
          ))}
        </div>

        <div className="product-results">
          <span>{filteredProducts.length} results</span>
        </div>

        <div className="product-grid">
          {filteredProducts.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image-wrapper">
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                />
                <div className="product-overlay">
                  <Link
                    onClick={toTop}
                    to={`/shopDetails/${product.id}`}
                    className="quick-view-btn"
                  >
                    Quick View
                  </Link>
                </div>
                <span className="product-badge">New</span>
              </div>
              <div className="product-info">
                <span className="product-category">{product.category}</span>
                <h3 className="product-name">{product.name}</h3>
                <div className="product-meta">
                  <div className="product-rating">
                    <span className="stars">★★★★☆</span>
                    <span className="rating-value">{product.rating}</span>
                    <span className="review-count">({product.reviews})</span>
                  </div>
                </div>
                <div className="product-footer">
                  <span className="product-price">${product.price}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
      <button className="back-to-top" onClick={toTop}>
        ↑
      </button>
    </div>
  );
}

export default Shop;
